export enum ZeosListEnum {
  companyType = 10,
  customerType = 11,
  propertyType = 12,
  deviceType = 13,
  BuildingType = 14,
  BuildingPriorWorkType = 15,
  HvacPrimaryType = 16,
  EspmPropertyTypeCategory = 17,
  EspmPropertyTypeDetail = 18,
}

export enum ZeosListOptionEnum {
  all = 10,
  excludeUnknown = 11,
  excludeOther = 12,
  excludeUtility = 13,
}

export enum DocumentCategoryEnum {
  Unknown = 0,
  Other = 1,
  Avatar = 10,
  PropertyImage = 11,
  UtilityBill = 12,
}

export enum DocumentTypeEnum {
  Unknown = 0,
  Other = 1,
  PDF = 10,
  WEBP = 11,
  PNG = 12,
  JPG = 13,
}

export enum EntityTypeEnum {
  Unknown = 0,
  Other = 1,
  User = 10,
  Property = 20,
}
